import { useEffect, useState } from "react";
import { toast } from "react-toastify";

import { useWeb3React } from "@web3-react/core";

import { useFirebase } from "./useFirebase";
import {
  useGnarlyGoatsContracts,
  useGnarlyGoatsContractsState
} from "./useGnarlyGoatsContracts";

const MAX_WHITELIST_COUNT = 1200

export function useWhitelist() {
	const { contract } = useGnarlyGoatsContracts()
	const { account } = useWeb3React()
	const { isOwner } = useGnarlyGoatsContractsState()
	const { getAddressWhitelistStatus, getWhitelistCount, getMerkleRoot } =
		useFirebase()

	const [isWhitelisted, setIsWhitelisted] = useState<boolean | undefined>(
		undefined
	)
	const [statusDescription, setStatusDescription] =
		useState<string>('Loading...')

	const [remainingSpots, setRemainingSpots] = useState<number>(-1)
	const [merkleRoot, setMerkleRoot] = useState<string>()

	const tryGetContractMerkleRoot = async () => {
		try {
			// get & set contract's merkle root
			setMerkleRoot(await contract?.merkleRoot())
		} catch (err) {
			setMerkleRoot('')
		}
	}

	const updateContractMerkleRoot = async () => {
		try {
			const root = await getMerkleRoot()
			await contract?.setMerkleRoot(`0x${root}`)
			setMerkleRoot(root)
		} catch (err) {
			//throw Error("Error setting contract merkle root.")
		}
	}

	useEffect(() => {
		const initWhitelistStatus = async () => {
			// // get & set account whitelist status from firebase
			const whitelistStatus = await getAddressWhitelistStatus()
			setIsWhitelisted(whitelistStatus)

			//update display status
			if (isWhitelisted === true) setStatusDescription('whitelisted')
			else if (isWhitelisted === false) setStatusDescription('not whitelisted')

			// // get & set total whitelist count from firebase
			const count = await getWhitelistCount()
			setRemainingSpots(MAX_WHITELIST_COUNT - count)
		}

		try {
			initWhitelistStatus()
		} catch (err) {}

		tryGetContractMerkleRoot()
	}, [account, contract, isWhitelisted])

	return {
		isWhitelisted,
		setIsWhitelisted,
		merkleRoot,
		updateMerkleRoot: updateContractMerkleRoot,
		statusDescription,
		remainingSpots,
	}
}
